import React, { useEffect, useState } from 'react';
import { Prompt, useHistory } from 'react-router-dom';
import { Location } from 'history';

import NavigationAlertDialog from '../NavigationAlertDialog';

export type NavigationPromptProps = {
  allowNavigation?: boolean;
  navigate?: (path: string) => void;
  id?: string;
  currentUrl?: string;
};

const NavigationPrompt = ({ allowNavigation, navigate, id, currentUrl }: NavigationPromptProps): JSX.Element => {
  const [openDialog, setOpenDialog] = useState(false);
  const [confirmedNavigation, setConfirmedNavigation] = useState(false);
  const [lastLocation, setLastLocation] = useState<Location | null>(null);

  const navigateTo = navigate || useHistory().push;
  const dialogLabelBy = `${id || 'navigation-prompt'}-alert`;
  const dialogDescribedBy = `${id || 'navigation-prompt'}-description`;

  const handleBlockedNavigation = (nextLocation: Location): boolean => {
    if (!confirmedNavigation && !allowNavigation && nextLocation.pathname !== currentUrl) {
      setOpenDialog(true);
      setLastLocation(nextLocation);
      return false;
    }
    return true;
  };

  const handleConfirm = () => {
    setOpenDialog(false);
    setConfirmedNavigation(true);
  };

  const handleCancel = () => {
    setOpenDialog(false);
  };

  useEffect(() => {
    if (confirmedNavigation && lastLocation) {
      navigateTo(lastLocation.pathname);
    }
  }, [confirmedNavigation, lastLocation]);

  return (
    <>
      <Prompt when={true} message={handleBlockedNavigation} />
      <NavigationAlertDialog
        open={openDialog}
        onClose={handleCancel}
        onConfirm={handleConfirm}
        labeledBy={dialogLabelBy}
        describedBy={dialogDescribedBy}
      />
    </>
  );
};

export default NavigationPrompt;
